/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskEvalsListReviews } from "../funcs/riskEvalsListReviews.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskEvalReviewsResult } from "../models/components/listriskevalreviewsresult.js";
import {
  ListRiskEvalReviewsRequest,
  ListRiskEvalReviewsSecurity,
} from "../models/operations/listriskevalreviews.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListEvalReviewsQueryData = ListRiskEvalReviewsResult;

export function prefetchRiskListEvalReviews(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListRiskEvalReviewsRequest,
  security?: ListRiskEvalReviewsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListEvalReviewsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListEvalReviewsQuery(
  client$: GramCore,
  request: ListRiskEvalReviewsRequest,
  security?: ListRiskEvalReviewsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListEvalReviewsQueryData>;
} {
  return {
    queryKey: queryKeyRiskListEvalReviews({
      policyId: request.policyId,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function riskListEvalReviewsQueryFn(
      ctx,
    ): Promise<RiskListEvalReviewsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskEvalsListReviews(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListEvalReviews(
  parameters: {
    policyId: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "evals", "listReviews", parameters];
}
